var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"font-family":"Inter"}},[_c('q-header',[_c('FirstToolbarComponent'),_c('SecondToolbarComponent')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }